export const GLORIA_PATRI: [string, string][] = [
    [
        "Glo_ry be to the /Fa_ther, and /to the /Son",
        "and /to the /Ho_ly Ghost.",
    ],
    [
        "As it was in the be_ginn_ing, is now, and /e_ver /shall be,",
        "/world with_out /end. A_men.",
    ],
];
